module.exports = __webpack_public_path__ + "img/logo_pruebate.6a72197e.svg";